import { send } from './saveHttp';

/** Which of the patient's two designations a write is setting. */
export type PrimaryDatasetKind = 'image' | 'structureSet';

const ENDPOINT: Record<PrimaryDatasetKind, string> = {
    image: 'primary-image',
    structureSet: 'primary-structure-set',
};

/**
 * Hand-written client for the connector-next primary-designation endpoints
 * (the generated client is not used for mutations that need If-Match — the
 * HTTP conventions live in `saveHttp.ts`, shared with the save clients).
 *
 * A null `datasetId` clears the designation. Cleared means "not chosen", not
 * "use the heuristic": the open then falls back to its own defaults, which is
 * a different statement and one the user can make deliberately.
 */
export async function postPrimaryDataset(
    patientId: string,
    kind: PrimaryDatasetKind,
    datasetId: string | null,
    ifMatch: string
): Promise<void> {
    await send(
        `/api/patients/${patientId}/${ENDPOINT[kind]}`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ datasetId }),
        },
        ifMatch
    );
}
